import { useState } from 'react'

export function useDragOverZone({ onDragOver }) {
  const [inlineOver, setInlineOver] = useState(false)
  const [attachOver, setAttachOver] = useState(false)

  function hasFiles(e) {
    const types = e?.dataTransfer?.types

    return !!types && (types.includes?.('Files') || types[0] === 'Files')
  }

  function handleDragInlineOver(e) {
    if (hasFiles(e)) {
      setInlineOver(true)
      setAttachOver(false)
      onDragOver()
    }
  }

  function handleDragInlineLeave() {
    setInlineOver(false)
  }

  function handleDragAttachOver(e) {
    setInlineOver(false)

    if (hasFiles(e)) {
      setAttachOver(true)
      onDragOver()
    }
  }

  function handleDragAttachLeave() {
    setAttachOver(false)
  }

  return {
    attachOver,
    handleDragAttachLeave,
    handleDragAttachOver,
    handleDragInlineLeave,
    handleDragInlineOver,
    inlineOver,
  }
}
